import { render, staticRenderFns } from "./BuildingDetailInstaller.vue?vue&type=template&id=be257324"
import script from "./BuildingDetailInstaller.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingDetailInstaller.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports